export default __webpack_public_path__ + "static/media/icon_temporal_overview.db0c79b2.svg";